<template>
	<b-card id="OfertasParaPago" no-body>
		<b-tabs card>
			<b-tab v-for="pType in programTypes" active-tab-class=""
				:title="pType.label"
				:key="pType.type"
				:active="value.type == pType.type"
				@click="setType(pType.type)">
                
				<swiper ref="swiper" :options="options" id="swiper-main">
					<div class="swiper-button-prev" slot="button-prev"></div>
					<div class="swiper-button-next" slot="button-next"></div>

					<swiper-slide v-for="item in filtered" :key="item.id">
						<div
							:class="{ active: value.offerId == item.id }"
							class="p-2 item"
							@click="setOffer(item.id)"
						>
							<api-img
								class="paq-img"
								:comp="item.imagenes_id"
								width="100%"
							/>

							<h5 class="planName">{{ item.planName }}</h5>

							<p v-html="item.descr"></p>

							<div class="iconify-holder">
								<h5
									class="iconify hotspot"
									v-if="item.hotspot == '1'"
								>
									<i class="i-hotspot"></i>
									<span>Hotspot</span>
								</h5>

								<h5
									class="iconify monthly"
									v-if="item.monthly == '1'"
								>
									<i class="i-monthly"></i>
									<span>Por Mes</span>
								</h5>
							</div>
						</div>
					</swiper-slide>
				</swiper>
			</b-tab>
		</b-tabs>
	</b-card>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
let programTypes = [
	{ type: "planMovil", label: "Movilidad" },
	{ type: "planMifi", label: "MiFi" },
	{ type: "planCasa", label: "Casa" },
];
export default {
	name: "OfertasParaPago",
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					type: "planMovil",
					offerId: null,
				};
			},
		},
	},
	computed: {
		...mapGetters(["OfertaGetCatalogo"]),
		options() {
			return {
				slidesPerView: 2,
				spaceBetween: 5,
				initialSlide: this.initialSlide,
				// pagination: {
				//     el: '.swiper-pagination',
				//     clickable: true,
				// },

				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},

				breakpoints: {
					// 1300: { slidesPerView: 4 },
					768: { slidesPerView: 3 },
					420: { slidesPerView: 2 },
					1: { slidesPerView: 1 },
				},
			};
		},
		filtered() {
			return _.filter(this.OfertaGetCatalogo, (item) => {
				return item.tipo == this.value.type;
			});
		},
	},
	data: () => {
		return {
			programTypes,
			initialSlide: 0,
		};
	},
	methods: {
		setOffer(id) {
			let val = _.clone(this.value);
			val.offerId = id;
			this.$emit("input", val);
		},
		setType(type) {
			let val = _.clone(this.value);
			val.type = type;
			this.$emit("input", val);
		},
	},
	beforeMount() {
		if (!this.value.type) {
			let val = _.clone(this.value);
			val.type = programTypes[0].type;
			this.$emit("input", val);
		}
		if (!!this.value.offerId) {
			let indexOfCurrent = _.findIndex(this.filtered, {
				id: this.value.offerId,
			});
			this.initialSlide = indexOfCurrent;
		}
	},
};
</script>

<style lang="less">
#OfertasParaPago {
	@imgSize: 6em;

	a {
		color: var(--primary);
	}

	.card-body {
		padding: 0;
	}

	#swiper-main {
		.swiper-wrapper {
			flex-basis: unset;
			align-items: stretch;

			.swiper-slide {
				min-height: 120px;
				display: flex;
				align-items: center;
				flex-shrink: 0;
				display: flex;
				align-items: top;
				height: auto;
				.item {
					margin-bottom: 10px;
					margin-bottom: 30px;
					margin: 0 30px 7px 30px;
					border-bottom: 2px solid transparent;
					text-align: center;
					height: 100%;

					.planName {
						color: var(--primary);
						font-weight: bold;
						position: relative;
						top: 0.4em;
					}

					p {
						border-top: 1px solid var(--dimmed);
						margin-top: 17px;
						padding-top: 10px;
						font-size: 0.7rem;
					}

					.iconify {
						white-space: nowrap;

						&,
						& > * {
							font-size: 0.8rem !important;
						}

						i {
							position: relative;
							display: inline-block;
							top: 0.1em;
							width: 1.5em;
							height: 1em;
							background-position: center;
							background-repeat: no-repeat;
							background-size: contain;
							// background-image: url('public/images/pages/home/hotspot.svg');
						}

						&.hotspot {
							i {
								background-image: url("public/images/pages/home/hotspot.svg");
							}
						}

						&.monthly {
							i {
								background-image: url("public/images/pages/home/month.svg");
							}
						}
					}

					.paq-img {
						width: @imgSize;
						height: @imgSize;
						object-fit: contain;
						background: white;
						border-radius: 1em;
						margin-top: 7px;
					}

					&:hover {
						cursor: pointer;
						background: hsla(269, 100%, 39%, 0.1);
					}

					&.active {
						border-bottom-color: var(--primary);
						background-color: var(--primary-transparent);
					}
				}
			}
		}
	}

	.swiper-pagination-fraction,
	.swiper-pagination-custom,
	.swiper-container-horizontal > .swiper-pagination-bullets {
		bottom: 0px;
	}

	.swiper-button-prev,
	.swiper-button-next {
		top: 50%;
		width: calc(var(--swiper-navigation-size) / 44 * 27);
		height: var(--swiper-navigation-size);
		margin-top: -1.3em;
		color: var(--swiper-navigation-color, var(--primary));
		transform: scale(0.75);
	}

	.swiper-button-next,
	.swiper-container-rtl .swiper-button-prev {
		right: 5px;
	}

	.swiper-button-prev,
	.swiper-container-rtl .swiper-button-next {
		left: 5px;
	}

	.swiper-pagination-bullet-active {
		background: var(--swiper-pagination-color, var(--primary));
	}

	.iconify-holder {
		padding: 0;
		position: relative;
		top: 0.25em;
		.iconify {
			/* margin-bottom: 1em; */
			margin-bottom: 0;
		}
	}

}
</style>